<template>
  <v-row justify="center" class="my-0">
    <v-dialog persistent max-width="290" :value="ooo">
      <v-card>
        <v-card-title class="headline">
          {{ $t(setDialog.title) }}
        </v-card-title>
        <v-card-text v-html="setDialog.message"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <i-btn
            v-if="setDialog.cancel"
            color="green darken-1"
            text
            @click="cancel()"
          >
            {{ $t(setDialog.cancelBtn) }}
          </i-btn>
          <i-btn color="green darken-1" text @click="close()">
            {{ $t(setDialog.okBtn) }}
          </i-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    setDialog: {
      default: function() {
        return {
          dialog: false,
          message: '',
          title: '',
          okBtn: '확인',
          cancelBtn: '취소',
          cancel: false,
        };
      },
      type: Object,
    },
  },
  methods: {
    cancel: function() {
      this.$emit('cancel');
      return false;
    },
    close: function() {
      this.$emit('close');
      return true;
    },
  },
  computed: {
    ooo: function() {
      return this.setDialog.dialog;
    },
  },
};
</script>

<style></style>
